import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SpaContext } from '../../../../Classes/spacontext';
import { VisibaApiHttp } from '../../../../Classes/visibaHttp.class';
import { FormOpportunity } from '../../../Constants/FormOpportunity';
import { AnswerApiModel } from '../Models/AnswerApiModel';
import { FormApiModel } from '../Models/FormApiModel';
import { FormGraphApiModel } from '../Models/FormGraphApiModel';
import { RespondantApiModel } from '../Models/RespondantApiModel';

@Injectable()
export class DynamicFormServiceV2 {
	private baseUri = () => `/api/Client/v2/units/${this.spaContext.unitConfig.Unit.UnitId}`;

	constructor(
		private http: VisibaApiHttp,
		private spaContext: SpaContext,
	) {
		// Empty
	}

	public getAllForms(conditionId: number = null, opportunity: FormOpportunity = null) {
		let params = new HttpParams();

		if (conditionId !== null) params = params.append('conditionId', conditionId.toString());
		if (opportunity !== null) params = params.append('opportunity', opportunity);

		return this.http.getTyped<FormApiModel[]>(`${this.baseUri()}/forms`, true, { params });
	}

	public get(id: number) {
		return this.http.getTyped<FormGraphApiModel>(`${this.baseUri()}/forms/${id}`, true);
	}

	public getRespondant(respondantId: number) {
		return this.http.getTyped<RespondantApiModel>(`${this.baseUri()}/forms/respondants/${respondantId}`, true);
	}

	public answer(id: number, model: AnswerApiModel[]) {
		return this.http.postTyped<AnswerApiModel[]>(`${this.baseUri()}/forms/respondants/${id}/answers`, model);
	}

	public setCompletion(respondantId: number) {
		return this.http.postTyped(`${this.baseUri()}/forms/respondants/${respondantId}/completion`, null);
	}

	public submitForm(respondantId: number, answers: AnswerApiModel[]) {
		return this.answer(respondantId, answers);
	}
}
